import { dmnStorage } from "../../utils/dmnStorage";
import { listenerMiddleware } from "../listenerMiddleware";
import { subscriptionIdChanged } from "../slices/sessionSlice";

export const registerSessionListeners = () =>
  listenerMiddleware.startListening({
    actionCreator: subscriptionIdChanged,
    effect: (action) => {
      dmnStorage.add("SubscriptionId", action.payload);
    }
  });
